export default function(nga, admin) {
    let entity = admin.getEntity('config')
        .label('Configs');

    entity.listView()
        .fields([
            nga.field('id').isDetailLink(true),
            nga.field('variable.name').isDetailLink(true)
        ])
        .sortDir('asc')
        .url('configs');

    entity.creationView()
        .fields([
            nga.field('game.id', 'reference')
                .label('Game')
                .map(function truncate(value, entry) {
                    return entry['game.id'];
                })
                .targetEntity(nga.entity('game').url('games'))
                .targetField(nga.field('name')),
            nga.field('variable', 'reference')
                .map(function truncate(value, entry) {
                    return entry['variable.id'];
                })
                .targetEntity(nga.entity('variable').url('variables'))
                .targetField(
                    nga.field('name')
                )
                .perPage(0)
                .remoteComplete(true, {
                    refreshDelay: 200,
                    searchQuery: search => ({ q: search })
                }),
            nga.field('max'),
            nga.field('min'),
            nga.field('modify_fixed'),
            nga.field('steps')
        ]);

    entity.creationView()
        .fields(
            nga.field('modify_relation', 'embedded_list')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key')
                        .label('Percentage'),
                    nga.field('value')
                ])
                .template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'),
            nga.field('modify_variable', 'embedded_list')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key')
                        .label('Percentage'),
                    nga.field('value')
                ])
                .template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array'),
            nga.field('hardness_initial', 'embedded_list')
                .targetFields([ // which comment fields to display in the datagrid / form
                    nga.field('key')
                        .label('Group'),
                    nga.field('value')
                        .label('Hardness')
                ])
                .template('<ma-input-array field="::field" value="value" datastore="::datastore"><ma-input-array')
        ).onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
            progression.done();

            notification.log(`Element #${entry._identifierValue} successfully created.`, { addnCls: 'humane-flatty-success' });

            $state.go($state.get('show'), { entity: 'game', id : entry.values['game.id'] });

            return false;
        }]);

    entity.editionView()
        .fields(entity.creationView().fields());

    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/config/config.js
 **/